import runtime from '../runtime';
import { validateNativeApiOrigin } from './nativeConfig.mjs';

export const getApiBaseUrl = () => {
    if (runtime.isNative()) {
        return validateNativeApiOrigin(import.meta.env.VITE_NATIVE_API_BASE_URL);
    }

    return import.meta.env.MODE === 'development'
        ? import.meta.env.VITE_BASE_URL
        : '';
};

export const getClientMetadata = () => ({
    platform: runtime.getPlatform(),
    version: import.meta.env.VITE_VERSION || 'web'
});
